module.exports = __webpack_public_path__ + "static/assets/2fa56bff56aabf682eed20ddd2ddd0a0.svg";